<template>
  <div :class="{ 'tx-Taxons_ListItem-indented': indented }" class="tx-Taxons_ListItem">
    <a
      :href="link"
      :class="{ 'tx-Taxons-active': active, 'justify-content-start': ancestor }"
      class="tx-Taxons_Link"
    >
      <ChevronLeft v-if="ancestor" class="svg-16 text-gray-500 pr-1" />
      <span class="text-truncate">{{ name }}</span>
      <span v-if="!ancestor && count" class="tx-Taxons_Count">{{ count }}</span>
    </a>
  </div>
</template>

<script>
import ChevronLeft from "../../icons/atalanda/chevron-left.svg";

export default {
  name: "TaxonItem",
  components: {
    ChevronLeft,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    link: {
      type: String,
      required: true,
    },
    count: {
      type: String,
      default: "",
    },
    active: {
      type: Boolean,
    },
    ancestor: {
      type: Boolean,
    },
    indented: {
      type: Boolean,
    },
  },
};
</script>
